module.exports = __webpack_public_path__ + "fonts/CeraPro-Regular.8ce61b71.woff";